import { useQuery } from '@tanstack/react-query';
import { concat, find, get, map } from 'lodash';
import { IViewAssembly } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetAssemblyWithComponents = (
  filters: string[] = [],
  enabled: boolean = true,
) =>
  useQuery({
    queryKey: queryKeys.viewAssembliesWithComponents.all(filters),
    queryFn: () => fetchAssemblyWithComponents(filters),
    enabled: enabled,
    staleTime: Infinity,
  });

const fetchAssemblyWithComponents = async (filters: string[] = []) => {
  const query = generateQuery(['layouts'], concat(filters, ['pageSize=0']));

  const url = `/viewAssembliesWithComponents${query}`;

  const response = await requestCCApi({
    url,
  });

  const layouts = get(response, 'includes.layouts.data', []);

  return map(response.data, (assembly) => ({
    ...assembly,
    layout: find(layouts, { id: assembly.layout_id }),
  })) as IViewAssembly[];
};
